import React from 'react';
import PropTypes from 'prop-types';
import { FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';

export const ConnectionsPageActions = ({
  connectionPageResource,
  addInstitution,
}) => {
  return (
    <FDStack spacing={1} wrap justifyContent="flex-end">
      {connectionPageResource.withRelationship(fr.relationships.householdBalanceSheet.name, (rel) => {
        return (
          <FDPrimaryActionButton
            icon={'home'}
            label={rel.meta('prompt')}
            onClick={() => addInstitution(rel)}
            size={'sm'}
            {...dataAttrs('back-to-balance-sheet-btn')}
          />
        );
      }, () => null)}
      {connectionPageResource.withRelationship(fr.relationships.addConnection.name, (rel) => {
        return (
          <FDPrimaryActionButton
            icon={'accountBalance'}
            label={rel.meta('prompt')}
            onClick={() => addInstitution(rel)}
            size={'sm'}
            {...dataAttrs('connection-add-account-action-btn')}
          />
        );
      }, () => null)}
    </FDStack>
  );
};

ConnectionsPageActions.defaultProps = {
};

ConnectionsPageActions.propTypes = {
  connectionPageResource: PropTypes.object.isRequired,
  addInstitution: PropTypes.func.isRequired,
};
